import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  const featuredCategories = categories.slice(0, 6);
  const remainingCategories = categories.slice(6);

  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="mb-14">
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-3">
            Shop by Category
          </h2>
          <p className="text-base text-foreground-500">
            Browse our curated product spreadsheets organized by category
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredCategories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-2xl bg-background-100 border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden bg-background-200/50">
                <img
                  src={cat.cardUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6 text-center">
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-1">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-500 mb-4">
                  {idx === 0 ? "1,200+ items tracked" : "800+ items tracked"}
                </p>
                <span
                  className={`inline-block px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 ${
                    idx === 0
                      ? "bg-primary-500 text-background-50 group-hover:bg-primary-600"
                      : "border border-foreground-300 text-foreground-600 group-hover:border-primary-400 group-hover:text-primary-600"
                  }`}
                >
                  View {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {remainingCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-2 px-4 py-3 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-background-50 transition-all duration-200 cursor-pointer"
            >
              <div className="w-7 h-7 rounded-lg overflow-hidden flex-shrink-0">
                <img
                  src={cat.thumbUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <span className="text-xs text-foreground-600 font-medium whitespace-nowrap">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}